import appStore from '@storages/appStore'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default {
  methods: {
    createPopup (e, blockId) {
      this.destroyPopup()
      // let x = e.event.event.zrX - 107
      // let y = e.event.event.zrY - 65
      let x = e.event.event.zrX
      let y = e.event.event.zrY

      let _wrapper = document.createElement('div')
      _wrapper.style.position = 'fixed'
      _wrapper.style.zIndex = '22'
      _wrapper.style.top = y + 'px'
      _wrapper.style.left = x + 'px'
      _wrapper.id = 'popupWrapper'

      let _close = document.createElement('div')
      _close.style.position = 'absolute'
      _close.style.top = '5px'
      _close.style.right = '5px'
      _close.innerHTML = '<?xml version="1.0"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve" width="12px" height="12px"><g><g><g><path d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#777676"/></g></g></g> </svg>'
      _close.id = 'popupClose'
      _close.onclick = e => { this.destroyPopup() }

      let _arrow = document.createElement('div')
      _arrow.id = 'popupArrow'

      let _div = document.createElement('div')
      _div.id = 'chartPopup'

      let _buttonsBlock = document.createElement('div')
      _buttonsBlock.id = 'popupButtonsBlock'

      let _titleBlock = document.createElement('div')
      // if (e.name !== null && e.name !== undefined) {
      //   _titleBlock.id = 'popupTitle'
      //   _titleBlock.innerText = e.name
      // }
      _titleBlock.id = 'popupTitle'
      let _locale = appStore.getters.value('locale')
      _titleBlock.innerText = _locale === 'en' ? 'View on the map?' : 'Посмотреть на карте?'

      let _buttonOnMap = document.createElement('div')
      _buttonOnMap.innerHTML = _locale === 'en' ? 'Go to map &#8594;' : 'Перейти &#8594;'
      _buttonOnMap.id = 'popupButtonOnMap'
      let _di = e.dataIndex
      _buttonOnMap.onclick = e => { this.$emit('go', {dataIndex: _di, blockId: blockId}) }

      let _buttonGoChild = document.createElement('div')
      _buttonGoChild.innerText = _locale === 'en' ? 'Details' : 'Подробнее'
      _buttonGoChild.id = 'popupButtonGoChild'
      _buttonGoChild.onclick = e => { this.$emit('getChildParams', {dataIndex: _di, blockId: blockId}) }

      _buttonsBlock.appendChild(_buttonGoChild)
      _buttonsBlock.appendChild(_buttonOnMap)
      _div.appendChild(_close)
      _div.appendChild(_titleBlock)
      _div.appendChild(_buttonsBlock)

      _wrapper.appendChild(_div)
      _wrapper.appendChild(_arrow)

      return _wrapper
    },

    destroyPopup () {
      let popup = document.getElementById('popupWrapper')
      if (popup) {
        popup.remove()
      }
    },

    disableBodyScrollMix () {
      document.body.style.overflowY = 'hidden'
    },

    setBobyScrollMix (val, blockId) {
      let _elem = document.getElementById(blockId)
      if (val) {
        enableBodyScroll(_elem)
        clearAllBodyScrollLocks()
      } else {
        this.disableBodyScrollMix()
        disableBodyScroll(_elem)
      }
    },

    clearAllBodyScrollLocksMix () {
      clearAllBodyScrollLocks()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chartsGlobalMix.js